import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : 'rest/api/admin/tickets',
    id : null,
    customerCode : "",
    number : -1,
    isPriorityTicket : false,
    status : "",
    createdTime : null,
    queueName : "",
    venueName : "",
    organizationName : "",
    queueId : null,
    venueId : null,
    organizationId : null,
    counterName: "",
    customerCodeLastDigits: ""
});